"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReportFiltersFromAdvancedOptions = void 0;
require("@veeam/components/lib/AdvancedFilter/types");
require("../../core");
const getReportFiltersFromAdvancedOptions = (filterValue, options) => {
    return options.cols.reduce((acc, curr) => {
        curr.groups.forEach((group) => {
            group.items.forEach((item) => {
                const hasValue = Array.isArray(filterValue)
                    ? filterValue.includes(item.value)
                    : filterValue === item.value;
                if (!hasValue) {
                    return;
                }
                if (!Array.isArray(acc[group.groupName])) {
                    acc[group.groupName] = [];
                }
                acc[group.groupName].push(item.value);
            });
        });
        return acc;
    }, {});
};
exports.getReportFiltersFromAdvancedOptions = getReportFiltersFromAdvancedOptions;
//# sourceMappingURL=getReportFiltersFromAdvancedOptions.js.map